angular
  .module("naturalPersonCensus.components", ["app.services"])
  .component("naturalPersonCensus", {
    templateUrl: "ng/components/naturalPersonCensus/naturalPersonCensus.view.html",
    controllerAs: "NaturalPersonCensusCtrl",
    bindings: {
      userDaCensire: "=",
      modal: "<"
    },
    controller: function (
      verifyUniqueService,
      $scope,
      $timeout,
      HttpService,
      $filter,
      validationService,
      $rootScope,
      $modalService,
      FileUploader,
      $configService,
      $istatService
    ) {
      var self = this;

      var destroyWatcher = function (variable) {
        $scope.$watch(
          function () {
            return variable;
          },
          function () {
            console.log("watch su: ", variable, " distrutto!");
          }
        );
      };

      self.$onInit = function () {
        self.mapComuni = $rootScope.comuniMap;
        self.listaProvince = [];
        self.listaNomeComuni = [];
        self.listaNomeComuniDiRilascio = [];
        self.listaCap = [];
        self.uploading = false;
        self.imgCf = "";
        self.imgDocumentoIdentita = "";
        self.dropdown = {
          ruolo: [],
          stati: [],
          comune: [],
          statiEsteri: [],
          entiRilascio: []
        };
        self.warnings = {
          cf: false,
          email: false,
          errorMsg: {
            cf: "",
            document: {
              dataRilascio: "",
              luogo: ""
            }
          },
          document: {
            dataRilascio: false,
            luogo: false
          }
        };
        self.userDaCensire = self.userDaCensire;
        self.modal = self.modal || false;

        self.getFromDomain(
          "RI_DROPDOWN_DOMAINS",
          "ROLE",
          "ruolo",
          0,
          function () {
            self.dropdown.ruolo = self.dropdown.ruolo.filter(function (el) {
              return el.description.split("|").indexOf("ADV") != -1;
            });
          }
        );

        $istatService.getNazioni()
          .then(function (response) {
            self.dropdown.stati = response.domainList;

            self.dropdown.statiEsteri = self.dropdown.stati.filter(
              function (elem) {
                return elem.name != "ITALIA";
              }
            );
          });

        self.getFromDomain(
          "RI_DROPDOWN_DOMAINS",
          "DOCUMENT_TYPE",
          "tipiDocumento",
          20,
          function () {
            for (i = 0; i < self.dropdown.tipiDocumento.length; i++) {
              if (self.dropdown.tipiDocumento[i].value == "CAE") {
                self.dropdown.tipiDocumento[i].order = 40;
              }
              if (self.dropdown.tipiDocumento[i].value == "CAI") {
                self.dropdown.tipiDocumento[i].order = 10;
              }
              if (self.dropdown.tipiDocumento[i].value == "CIE") {
                self.dropdown.tipiDocumento[i].order = 20;
              }
              if (self.dropdown.tipiDocumento[i].value == "NCE") {
                self.dropdown.tipiDocumento[i].order = 30;
              }
              if (self.dropdown.tipiDocumento[i].value == "PAM") {
                self.dropdown.tipiDocumento[i].order = 50;
              }
              if (self.dropdown.tipiDocumento[i].value == "PAS") {
                self.dropdown.tipiDocumento[i].order = 80;
              }
              if (self.dropdown.tipiDocumento[i].value == "PAT") {
                self.dropdown.tipiDocumento[i].order = 60;
              }
              if (self.dropdown.tipiDocumento[i].value == "UCO") {
                self.dropdown.tipiDocumento[i].order = 70;
              }
            }
          }
        );

        self.getFromDomain(
          "RI_DROPDOWN_DOMAINS",
          "DOCUMENT_ISSUER",
          "entiRilascio",
          120
        );

        self.listaProvince = self.mapComuni
          .map(function (comune) {
            return comune.sigla
          })
          .filter(function (siglaComune) {
            return siglaComune != ""
          })
          .sort()
          .reduce(function (result, nextItem) {
            return result.includes(nextItem) ? result : result.concat(nextItem)
          }, []);


        if (typeof self.userDaCensire == "undefined" || typeof self.userDaCensire == "object" || Object.keys(self.userDaCensire).length === 0) {
          return;
        }
        var watchSuProvinciaDiNascita = $scope.$watch(
          function () {
            return self.userDaCensire;
          },
          function (newValue, oldValue) {
            if (!newValue) return;
            if (newValue !== oldValue) {
              self.userDaCensire.comuneDiNascita = "";
              self.creaComuniNascita(newValue);
            }
          },
          true
        );

        var watchSuProvinciaDiResidenza = $scope.$watch(
          function () {
            return self.userDaCensire.provinciaDiResidenza;
          },
          function (newValue, oldValue) {
            if (!newValue) return;
            if (newValue !== oldValue) {
              self.userDaCensire.comuneDiResidenza = "";
              self.creaComuniResidenza(newValue);
            }
          },
          true
        );

        var watchSuCap = $scope.$watch(
          function () {
            return self.userDaCensire.comuneDiResidenza;
          },
          function (newValue, oldValue) {
            if (!newValue) return;
            if (newValue !== oldValue) {
              self.userDaCensire.cap = "";
              self.creaCap(newValue);
            }
          },
          true
        );

        var watchSuDocumentoComune = $scope.$watch(
          function () {
            return self.userDaCensire.documento.provincia;
          },
          function (newValue, oldValue) {
            if (!newValue) return;
            if (newValue !== oldValue) {
              self.userDaCensire.documento.luogo = "";
              self.creaComuniRilascioDocumento(newValue);
            }
          },
          true
        );

        /*	$scope.$watch(function() { return vm.radioSelection}, function(newVal,     oldVal) {
          vm.message = "Your selection is " + newVal;
        }, true); */



        self.validationObj = {
          documentDate: {
            disabledDays: [0],
            disabledDates: [
              "01-01",
              "06-01",
              "25-04",
              "01-05",
              "02-06",
              "15-08",
              "01-11",
              "08-12",
              "25-12",
              "26-12"
            ]
          },
          regex: {
            documentNumber: /.+/
          }
        };

        self.warnings = {
          cf: false,
          email: false,
          errorMsg: {
            cf: "",
            document: {
              dataRilascio: "",
              luogo: ""
            }
          },
          document: {
            dataRilascio: false,
            luogo: false
          }
        };

        if (self.userDaCensire.titolare.selected) {
          isTitolare = true;
          if (self.userDaCensire.titolare.pep === "Y") {
            infoTitolare = !!(
              self.userDaCensire.titolare.pep &&
              self.userDaCensire.titolare.motivazione
            );
          } else {
            infoTitolare = !!self.userDaCensire.titolare.pep;
          }
        }
        if (self.userDaCensire.firmatario.selected) {
          isFirmatario = true;
          infoFirmatario = !!self.userDaCensire.firmatario.ruolo &&
            self.userDaCensire.telefono &&
            self.userDaCensire.email && // Todo: decommentare - fix temporaneo, in attesa dell'upgrade del componente
            self.checkEmail(self.userDaCensire.email); // Todo: decommentare - fix temporaneo, in attesa dell'upgrade del componente
        }

      };

      self.undoDocumentChanges = function (pf, idModal) {
        //$scope.currentPf.documento = Object.assign({}, self.datiDocumento);
        $("#" + idModal)
          .modal("hide")
          .data("bs.modal", null);
      };

      self.today = moment(new Date()).format("DD/MM/YYYY");

      self.getFromDomain = function (table, value, list, delay, cb) {
        $timeout(function () {
          HttpService.send(
            "/uni/typedomain/getDomainSet", {
            table: table,
            column: value
          },
            false
          ).then(function (response) {
            if (list) {
              self.dropdown[list] = response.domainList;
            }

            if (cb) {
              cb(response);
            }
          });
        }, delay);
      };

      self.test = function () {
        $("input").removeClass("has-error");
      }


      self.checkField = function (field, value, userDaCensire) {
        //return field === 'cf' ? checkCF(value) : checkPIVA(value);
        if (userDaCensire) {
          if (checkCF(value)) {
            userDaCensire.sesso =
              userDaCensire.codiceFiscale.slice(9, 11) < 40 ? "m" : "f";

            if (self.isForeignCf(userDaCensire.codiceFiscale)) {
              userDaCensire.provinciaDiNascita = "EE";
              var codiceStato = userDaCensire.codiceFiscale.substr(11, 4);
              var stato = self.dropdown.stati.find(function (el) {
                return el.value == codiceStato;
              });
              if (stato) {
                userDaCensire.comuneDiNascita = stato.name;
              }
            }
            return true;
          } else return false;
        } else return checkCF(value);

        function checkCF(cf) {
          var validi, i, s, set1, set2, setpari, setdisp;
          if (typeof cf == "undefined") {
            return;
          }
          cf = cf.toUpperCase();
          if (cf.length != 16) {
            self.warnings.errorMsg.cf =
              "La lunghezza del codice fiscale non è\n" +
              "corretta: il codice fiscale dovrebbe essere lungo\n" +
              "esattamente 16 caratteri.\n";
            return false;
          }
          validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
          for (i = 0; i < 16; i++) {
            if (validi.indexOf(cf.charAt(i)) == -1) {
              self.warnings.errorMsg.cf =
                "Il codice fiscale contiene un carattere non valido `" +
                cf.charAt(i) +
                "'.\nI caratteri validi sono le lettere e le cifre.\n";
              return false;
            }
          }
          set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
          setpari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          setdisp = "BAKPLCQDREVOSFTGUHMINJWZYX";
          s = 0;
          for (i = 1; i <= 13; i += 2)
            s += setpari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
          for (i = 0; i <= 14; i += 2)
            s += setdisp.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
          if (s % 26 != cf.charCodeAt(15) - "A".charCodeAt(0)) {
            self.warnings.errorMsg.cf =
              "Il codice fiscale non è corretto:\n" +
              "il codice di controllo non corrisponde.\n";
            return false;
          }

          self.warnings.errorMsg.cf = "";

          return true;
        }
      };

      self.isForeignCf = function (cf) {
        return cf.substr(11, 1) == "Z";
      };

      self.check = function (el) {
        el.selected = !el.selected;
      };

      self.openDocumentModal = function () {
        $modalService.openModal("documentoRiconoscimento");

        self.datiDocumento = Object.assign({}, self.userDaCensire.documento);

        if (self.userDaCensire.documento.provincia) {
          self.citiesList = self.mapComuni.filter(function (comune) {
            return comune.sigla == self.userDaCensire.documento.provincia;
          });
          if (self.datiDocumento.luogo) {
            var luogo = self.citiesList.find(function (el) {
              return (
                el.nome.toUpperCase() ==
                self.userDaCensire.documento.luogo.toUpperCase()
              );
            });
            if (luogo) self.userDaCensire.documento.luogo = luogo;
            else {
              if (self.dropdown.stati) {
                var nazione = self.dropdown.stati.find(function (naz) {
                  return (
                    naz.name.toUpperCase() ===
                    self.userDaCensire.documento.luogo.toUpperCase()
                  );
                });
                if (nazione)
                  self.userDaCensire.documento.luogo = nazione.name;
              }
            }
          }
        }
        if (self.userDaCensire.documento.tipo) {
          self.setDocNumRegex(
            self.userDaCensire.documento.tipo,
            self.userDaCensire
          );
        }

        //	listener();
      };
      self.setDocNumRegex = function (doc, pf) {
        pf.documento.enteRilascio = self.dropdown.entiRilascio.find(function (
          ente
        ) {
          var docTypes = ente.description.split("|");
          return docTypes.indexOf(doc) != -1;
        });
        if (pf.documento.enteRilascio) {
          pf.documento.enteRilascio = pf.documento.enteRilascio.nome;
        }
        self.validationObj.regex.documentNumber = validationService.getDocTypeRegex(
          doc
        );

        switch (doc) {
          case propMap["DOC_TYPE_CAE"]:
            pf.documento.provincia = "EE";
            break;
          case propMap["DOC_TYPE_UCO"]:
            pf.documento.luogo = "MIT-UCO";
            break;
          default:
            break;
        }
      };

      self.checkThenOpenDocModal = function () {
        if (
          self.userDaCensire.dataDiNascita == undefined ||
          self.userDaCensire.dataDiNascita == null ||
          self.userDaCensire.dataDiNascita == ""
        )
          $rootScope.$broadcast("addAlert", {
            text: "ERROR_NO_BIRTHDATE"
          });
        else {
          console.log("DATA NASCITA=", self.userDaCensire.dataDiNascita);
          console.log("DATA NASCITA2=" + self.userDaCensire.dataDiNascita);
          //self.openDocumentModal();
          $modalService.openModal("documentoRiconoscimentoModale");
        }
      };

      self.getNsilDocument = function (type, cf) {
        var input = {
          cf: cf,
          type: type
        };
        verifyUniqueService.verifyDocument(input).then(function (response) {
          if (response.success) {
            if (response.document) {
              self.documentFromNsil = response.document;

              if (
                response.document.dataRilascio &&
                response.document.dataRilascio != "null"
              ) {
                self.documentFromNsil.dataRilascio = moment(
                  parseInt(response.document.dataRilascio)
                ).format("DD/MM/YYYY");
              }
              if (
                response.document.dataScadenza &&
                response.document.dataScadenza != "null"
              ) {
                self.documentFromNsil.dataScadenza = moment(
                  parseInt(response.document.dataScadenza)
                ).format("DD/MM/YYYY");

                var daysDiff = moment
                  .duration(
                    moment(
                      self.documentFromNsil.dataScadenza,
                      "DD/MM/YYYY"
                    ).diff(moment($scope.today, "DD/MM/YYYY"))
                  )
                  .asDays();
                if (daysDiff <= 0) {
                  self.documentFromNsil = null;
                }
              }
            } else {
              self.documentFromNsil = null;
            }
            console.log("document from NSIL: ", response.document);
          }
        });
      };

      self.isValidDocumentNumber = function (number) {
        if (number && number.length) {
          return self.validationObj.regex.documentNumber.test(number);
        }
        return true;
      };

      self.creaComuniResidenza = function (provincia) {
        self.comuniInProvincia = self.mapComuni.filter(function (comune) {
          return comune.sigla == provincia;
        });
        self.listaNomeComuni = self.comuniInProvincia.map(function (
          comuneInProvincia
        ) {
          return comuneInProvincia.nome;
        });
      };

      self.creaComuni = function (provincia) {

        self.listaNomeComuni = self.mapComuni
          .filter(function (comune) {
            return comune.sigla == provincia;
          }).map(function (
            comuneInProvincia
          ) {
            return comuneInProvincia.nome;
          });

      }

      self.creaComuniNascita = function (provincia) {
        self.comuniInProvincia = self.mapComuni.filter(function (comune) {
          return comune.sigla == provincia;
        });
        self.listaNomeComuni = self.comuniInProvincia.map(function (
          comuneInProvincia
        ) {
          return comuneInProvincia.nome;
        });
      };

      self.creaComuniRilascioDocumento = function (provincia) {
        self.comuniInProvincia = self.mapComuni.filter(function (comune) {
          return comune.sigla == provincia;
        });
        self.listaNomeComuniDiRilascio = self.comuniInProvincia.map(function (
          comuneInProvinciaRilascio
        ) {
          self.userDaCensire.documento.luogo = comuneInProvinciaRilascio.nome;
          return self.userDaCensire.documento.luogo;
        });
      };

      self.creaCap = function (comuneNome) {
        self.comuneDiResidenzaNome = self.mapComuni.filter(function (comune) {
          return comune.nome == comuneNome;
        });

        self.lista = self.comuneDiResidenzaNome.map(function (
          comuneSelezionato
        ) {
          self.listaCap = comuneSelezionato.cap;
          return self.listaCap;
        });
      };

      self.uploader = new FileUploader({
        url: '',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Token': 'Bearer ' + ($configService.getAppConfig().token || 'no-token'),
          'App-Name': $rootScope.portalName
        }
      });

      self.uploadDataFunc = function (item, index, privacy) {
        var document = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        if (item) {
          self.uploadData = item;
        }
        self.isPrivacyUpload = privacy;
        self.uploadDocumenti = document;
        self.currentCodeTypeNameIndex = index;
      }

      self.finalUpload = function (item) {
        console.log('calling finalUpload');
        self.folderPath = '' + new Date().getTime();
        var url;
        if (self.userDaCensire.codiceFiscale) {
          url = $configService.getAppConfig().url +
            "/uni/upload/service-infos/" +
            encodeURIComponent(self.userDaCensire.codiceFiscale) +
            "/PERSONAL_DOCUMENTS/PERSONAL_DOCUMENTS";
        } else {
          return;
        }

        for (var int = 0; int < self.uploader.queue.length; int++) {
          self.uploader.queue[int].url = url;
        }
        self.uploader.uploadAll();
      }

      self.uploader.onAfterAddingFile = function (fileItem) {

        if (self.uploadDocumenti == 'imgDocumentoIdentita') {
          self.imgDocumentoIdentita = self.uploadDocumenti;
        } else {
          self.imgCf = self.uploadDocumenti;
        }

        console.log('fileItem', fileItem);
        if (fileItem.file.size > 26214400) {
          $rootScope.$broadcast('addAlert', {
            text: 'MAXIMUM_FILE_SIZE_EXCEEDED'
          });
          fileItem.remove();
          $('#input-upload-' + self.currentCodeTypeNameIndex).val('');
        }
        var fileName = fileItem.file.name;
        if (fileName.toLowerCase().indexOf('.pdf') > -1 ||
          fileName.toLowerCase().indexOf('.png') > -1 ||
          fileName.toLowerCase().indexOf('.jpg') > -1 ||
          fileName.toLowerCase().indexOf('.jpeg') > -1) {
          self.uploader.queue[0].progress = 0;
        } else {
          fileItem.remove();
          $('#input-upload-' + self.currentCodeTypeNameIndex).val('');
          $rootScope.$broadcast('addAlert', {
            text: 'FORMAT_NOT_SUPPORTED'
          });
        }
      };

      self.uploader.onAfterAddingAll = function (addedFileItems) {
        console.info('onAfterAddingAll', addedFileItems);

        //Controllo upload documenti firma digitale se firmatario

        // if (self.uploadDocumenti == 'imgDocFirmatario1') {
        //   self.warnings.digitalSignDocuments['imgDocFirmatario1'] = true;
        // }

        self.uploading = true;
        self.finalUpload(self.uploadData);
      };

      self.uploader.onSuccessItem = function (fileItem, response, status, headers) {
        self.uploading = false;

      };

      self.uploader.onErrorItem = function (fileItem, response, status, headers) {
        self.uploading = false;
        if (self.uploadDocumenti == 'imgDocumentoIdentita') {
          self.imgDocumentoIdentita = "";
        } else {
          self.imgCf = "";
        }
        console.info('onErrorItem', fileItem, response, status, headers);
        $rootScope.$broadcast('addAlert', {
          text: 'ERROR_UPLOADING_FILE'
        });
        fileItem.remove();
        $('#input-upload-' + self.currentCodeTypeNameIndex).val('');
      };




      self.$onDestroy = function () {
        destroyWatcher(self.userDaCensire.provinciaDiNascita);
        destroyWatcher(self.userDaCensire.provinciaDiResidenza);
        destroyWatcher(self.userDaCensire.documento.provincia);
        destroyWatcher(self.userDaCensire.comuneDiResidenza);
      };

      self.checkEmail = function (email) {
        self.warnings.email = false;
        if (email && validationService.isValidEmail(email)) {
          self.warnings.email = true;
          return true;
        } else return false;
      };

      self.canSavePfData = function (pf) {
        if (pf.dataDiNascita) {
          // Test
          //pf = Object.assign({}, {datiNascita: {data: pf.dataDiNascita}});
          pf = Object.assign(pf, {
            datiNascita: {
              data: pf.dataDiNascita
            }
          });
          //pf.datiNascita.data = pf.dataDiNascita;
        }
        if (pf &&
          pf.datiNascita &&
          pf.codiceFiscale &&
          pf.nome &&
          pf.cognome &&
          pf.sesso &&
          pf.datiNascita.data
        ) {
          var cfInfo = {
            cf: {
              value: pf.codiceFiscale
            },
            nome: pf.nome,
            cognome: pf.cognome,
            sesso: {
              value: pf.sesso.toUpperCase()
            },
            Giorno: {
              value: pf.datiNascita.data.split("/")[0]
            },
            Mese: {
              value: pf.datiNascita.data.split("/")[1]
            },
            Anno: {
              value: pf.datiNascita.data.split("/")[2]
            }
          };

          var infoFirmatario = true;
          var infoTitolare = true;
          var isFirmatario = false;
          var isTitolare = false;
          var infoAnagrafiche = !!(
            pf.nome &&
            pf.cognome &&
            pf.sesso &&
            pf.datiNascita.data &&
            pf.datiNascita.provincia &&
            pf.datiNascita.comune &&
            pf.residenza.indirizzo &&
            pf.residenza.numeroCivico &&
            pf.residenza.provincia &&
            pf.residenza.comune &&
            pf.residenza.cap
          );

          var infoDocumento = !!(
            pf &&
            pf.documento &&
            pf.documento.tipo &&
            pf.documento.numero &&
            pf.documento.enteRilascio &&
            pf.documento.luogo &&
            (pf.documento.tipo == propMap["DOC_TYPE_PAS"] ||
              pf.documento.tipo == propMap["DOC_TYPE_CAE"] ||
              !!pf.documento.provincia) &&
            pf.documento.dataRilascio &&
            pf.documento.dataScadenza &&
            pf.documento.imgCf &&
            pf.documento.imgDocumentoIdentita
          );

          if (pf && pf.titolare && pf.titolare.selected) {
            isTitolare = true;
            if (pf.titolare.pep === "y") {
              infoTitolare = !!(pf.titolare.pep && pf.titolare.motivazione);
            } else {
              infoTitolare = !!pf.titolare.pep;
            }
          }
          if (pf && pf.firmatario && pf.firmatario.selected) {
            isFirmatario = true;
            infoFirmatario = !!pf.firmatario.ruolo &&
              pf.telefono &&
              pf.email &&
              self.checkEmail(pf.email);
          }
          if (!self.dropdown) {
            self.dropdown = {};
            return;
          }
          if (!cfChecker.validateCfFromInfo(cfInfo, self.dropdown.stati)) {
            $('input[name="codiceFiscale"]').addClass("has-error");
            self.warnings.errorMsg.cf =
              "Il codice fiscale o i dati inseriti sono errati.";
            return false;
          } else {
            $('input[name="codiceFiscale"]').removeClass("has-error");
            self.warnings.errorMsg.cf = "";
            if (!$scope.checkDocumentExpiryDate(pf)) return false;

            if (isTitolare && !isFirmatario) {
              if (infoAnagrafiche && infoDocumento && infoTitolare) {
                return true;
              }
            }

            return (
              (isTitolare || isFirmatario) &&
              infoAnagrafiche &&
              infoDocumento &&
              infoFirmatario &&
              infoTitolare
            );
          }
        } else return false;
      };

      self.savePfData = function (pf) {
        var fromTable =
          arguments.length > 1 && arguments[1] !== undefined ?
            arguments[1] :
            false;
        // var index = $scope.raccoltaInfo.listaPf.findIndex(function (el) {
        //   return el.codiceFiscale === $scope.currentPfCf;
        // });
        // $scope.raccoltaInfo.listaPf[index] = angular.copy($scope.currentPf);
        // if (!fromTable) {
        //   $scope.riViewObj.viewIndex = 1;
        // }
        // console.log($scope.raccoltaInfo.listaPf[index]);
        $modalService.closeModal("censusPerson");
      };

      self.discardChanges = function (pf) {
        $scope.riViewObj.viewIndex = 1;
      };

      self.isForeignCf = function (cf) {
        return cf && cf.substr(11, 1) == "Z";
      };

      self.editPf = function (pf) {
        var fromTable =
          arguments.length > 1 && arguments[1] !== undefined ?
            arguments[1] :
            false;
        pf.codiceFiscale = pf.codiceFiscale.toUpperCase();
        $scope.setDefaultPFValues(pf);
        $scope.currentPf = JSON.parse(JSON.stringify(pf));

        ///////////
        //if ($scope.currentPf.datiNascita.data == undefined) {
        //currentPf.sesso
        //}

        console.log("currentPf: ", $scope.currentPf);

        if ($scope.isForeignCf($scope.currentPf.codiceFiscale)) {
          $scope.currentPf.datiNascita.provincia = "EE";
        }

        $scope.currentPfCf = $scope.currentPf.codiceFiscale;
        if (!fromTable) {
          $scope.riViewObj.viewIndex = 4;
        } else {
          $scope.openDocumentModal();
        }
        if ($scope.currentPf.codiceFiscale && $scope.currentPf.documento.tipo) {
          $scope.getNsilDocument(
            $scope.currentPf.documento.tipo,
            $scope.currentPf.codiceFiscale
          );
        }
        console.log("currentPf: ", $scope.currentPf);
      };
    }
  });